import { useChartBuilderFactory } from "./useChartBuilderFactory";

export default useChartBuilderFactory;
